var _defs, _path, _path2, _text, _path3, _path4, _text2, _text3, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 690.89 636.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-4,.cls-5,.cls-8{stroke-miterlimit:10;}.cls-1{fill:url(#linear-gradient);stroke:url(#linear-gradient-2);}.cls-2{fill:url(#linear-gradient-3);stroke:url(#linear-gradient-4);}.cls-3{opacity:0.8;font-size:57.29px;}.cls-3,.cls-6,.cls-7,.cls-8{fill:#fff;}.cls-3,.cls-6,.cls-7{font-family:Poppins-SemiBold, Poppins;font-weight:600;}.cls-4{stroke:#515151;fill:url(#linear-gradient-5);}.cls-5{fill:url(#linear-gradient-6);stroke:url(#linear-gradient-7);}.cls-6{opacity:0.5;font-size:16.92px;letter-spacing:0.1em;}.cls-7{opacity:0.85;font-size:28.88px;}.cls-8{opacity:0.04;stroke:url(#linear-gradient-8);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 85.01,
    y1: 471.65,
    x2: 359.09,
    y2: 313.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7123b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 84.58,
    y1: 471.9,
    x2: 359.52,
    y2: 313.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7223b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 445.15,
    y1: 392.15,
    x2: 8.35,
    y2: 392.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 445.65,
    y1: 392.15,
    x2: 7.85,
    y2: 392.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 239.37,
    y1: 380.91,
    x2: 711.67,
    y2: 108.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a1aac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7422b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 236.44,
    y1: 377.98,
    x2: 708.75,
    y2: 105.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 236.01,
    y1: 378.23,
    x2: 709.18,
    y2: 105.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 229.39,
    y1: 371.31,
    x2: 7.98,
    y2: 371.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434343"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.83,349.77,282.46,181.16a39.07,39.07,0,0,0-41.83-22.84L39.18,190A39.08,39.08,0,0,0,9.3,243.94L164.36,608.51a39.06,39.06,0,0,0,43.44,23.06l203.54-39.69a39.08,39.08,0,0,0,28.28-54.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359,346.84,284.66,178.23a39.08,39.08,0,0,0-41.84-22.83L41.38,187.12A39.09,39.09,0,0,0,11.49,241L166.55,605.59A39.09,39.09,0,0,0,210,628.65L413.53,589a39.08,39.08,0,0,0,28.29-54.11Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "matrix(0.92, -0.17, 0.32, 0.95, 145.22, 400.75)"
  }, "pyme")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M339.31,206.52,405,34.35A39.07,39.07,0,0,1,445.66,9.43L648.46,30.9A39.08,39.08,0,0,1,681,83.22l-136.38,372a39.08,39.08,0,0,1-42.22,25.24L297.15,451.08a39.07,39.07,0,0,1-31-52.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M336.39,203.59,402.11,31.43A39.09,39.09,0,0,1,442.74,6.5L645.53,28a39.09,39.09,0,0,1,32.58,52.32l-136.39,372a39.08,39.08,0,0,1-42.22,25.23L294.22,448.16a39.09,39.09,0,0,1-31-52.61Z"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "matrix(0.9, 0.13, -0.37, 0.93, 384.38, 450.63)"
  }, "#1")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "matrix(0.92, 0.12, -0.37, 0.93, 363.93, 421.67)"
  }, "pyme")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M54.5,185l174.28-27.54L157.42,584l-147-344.78S2.83,217.9,17.82,200C21,196.93,28.55,188.89,54.5,185Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.17019fc3365f63cb148c667dac52aa6f.svg";
export { ForwardRef as ReactComponent };